import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query ListCompanies($uuid: ID!, $filter: ListCompaniesFilterInput!) {
    listCompanies(uuid: $uuid, filter: $filter) {
      name
      number
      country
      supplierId
      address {
        nameOrNumber
        street
        lineThree
        lineFour
        lineFive
        lineSix
        town
        county
        state
        country
        postcode
      }
    }
  }
`

export const listCompaniesKey = getQueryNames(query)[0]

export default query
